import { imageId } from './ImageStore';

import { imageIdDefault } from './ImageStoreDefaults';

export const resetImageId = () => {
	imageId.set(imageIdDefault);
};
